import { accessToken } from '../../configuration/tokenHandling/accessToken';

export const getRequest = (): RequestInit => ({
    method: 'GET',
    headers: {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
    },
});
